<template>
    <div class="row match-height"
         v-if="isLoaded">
        <div class="col-xl-12 col-lg-12">
            <ul class="nav nav-tabs nav-topline nav-justified"
                role="tablist">
                <li class="nav-item">
                    <a class="nav-link active"
                       href="#tabs-1-tab-1"
                       role="tab"
                       data-toggle="tab"
                       aria-expanded="true">
                        <span class="nav-link-in">
                            <i class="font-icon font-icon-cogwheel"></i>
                            EDI Entrada ( Notfis, Prefat, Ocorren)
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       href="#tabs-1-tab-2"
                       role="tab"
                       data-toggle="tab"
                       aria-expanded="false">
                        <span class="nav-link-in">
                            <i class="fa fa-list"></i>
                            EDI Saída ( Conemb / Doccob)
                        </span>
                    </a>
                </li>
            </ul>

            <div class="tab-content card">
                <div role="tabpanel"
                     class="tab-pane active show"
                     id="tabs-1-tab-1"
                     aria-expanded="true">
                    <div class="row match-height"
                         v-bind:class="{ fullscreen_expand: isFullscreen }">
                        <div class="col-xl-12 col-lg-12">
                            <div class="card"
                                 style="">
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <div class="card-header">
                                        <h4 class="card-title">Gerais</h4>
                                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                        <div class="heading-elements">
                                            <ul class="nav nav-tabs nav-topline nav-justified"
                                                role="tablist">
                                                <li><a @click="onCreate()"
                                                       v-b-tooltip
                                                       title="Cadastrar EDI de Entrada"><i class="ft-plus"
                                                           v-if="getPermission('parametrizacaoedi.store')"></i></a></li>
                                                <li><a @click="onActivateDesactivate(1, null, false)"
                                                       v-b-tooltip
                                                       title="Ativar Registros"
                                                       v-if="getPermission('parametrizacaoedi.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                                <li><a @click="onActivateDesactivate(2, null, false)"
                                                       v-b-tooltip
                                                       title="Inativar Registros"
                                                       v-if="getPermission('parametrizacaoedi.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                                <li><a @click="expandFullscreen()"
                                                       v-b-tooltip
                                                       title="Expande a tela"
                                                       v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                                <li><a @click="expandFullscreen()"
                                                       v-b-tooltip
                                                       title="Minimiza a tela"
                                                       v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                                <li><a @click="onFilterShowHide()"
                                                       v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="card-content">
                                        <div class="table-responsive col-md-12">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 20%">Layout</th>
                                                        <th style="width: 10%">Extensão Arq.</th>
                                                        <th style="width: 25%">Status FTP</th>
                                                        <th style="width: 25%">Status Email</th>
                                                        <th style="width: 10%">Status</th>
                                                        <th style="width: 10%">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="this.form_edi_entrada.length>0">
                                                    <template v-for="item in this.form_edi_entrada">
                                                        <tr class="bg-gray-light"
                                                            style="display: table-row;">
                                                            <td>
                                                                <span v-if="item.geral.b_layout.descr">
                                                                    {{ item.geral.b_layout.descr}}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {{ item.geral.extensao_arq}}
                                                            </td>
                                                            <td>
                                                                <span class="badge badge-success"
                                                                      v-if="item.geral.status_ftp.valor==1">{{ item.geral.status_ftp.descr}}</span>
                                                                <span class="badge badge-danger"
                                                                      v-if="item.geral.status_ftp.valor==2">{{ item.geral.status_ftp.descr}}</span>
                                                            </td>
                                                            <td>
                                                                <span class="badge badge-success"
                                                                      v-if="item.geral.status_email.valor==1">{{ item.geral.status_email.descr}}</span>
                                                                <span class="badge badge-danger"
                                                                      v-if="item.geral.status_email.valor==2">{{ item.geral.status_email.descr}}</span>
                                                            </td>
                                                            <td>
                                                                <span class="badge badge-success"
                                                                      v-if="item.geral.status.valor==1">{{ item.geral.status.descr }}</span>
                                                                <span class="badge badge-danger"
                                                                      v-if="item.geral.status.valor==2">{{ item.geral.status.descr }}</span>
                                                            </td>
                                                            <td>
                                                                <a @click="onDetail(item)"
                                                                   v-b-tooltip
                                                                   title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                                <a @click="onEdit(item)"
                                                                   v-b-tooltip
                                                                   title="Editar"
                                                                   v-if="getPermission('parametrizacaoedi.update')"><i class="fa fa-edit"></i></a>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="isVisibleDetailRow(item.geral.bcliedie_id)">
                                                            <td colspan="6">
                                                                <section class="tabs-section">
                                                                    <div class="tabs-section-nav">
                                                                        <div class="tbl">
                                                                            <ul class="nav"
                                                                                role="tablist">
                                                                                <li class="nav-item">
                                                                                    <a class="nav-link active"
                                                                                       href="#tabs-3-tab-1"
                                                                                       role="tab"
                                                                                       data-toggle="tab">
                                                                                        <span class="nav-link-in">
                                                                                            Detalhes
                                                                                            <i class="fa fa-bulding"></i>
                                                                                        </span>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <!--.tabs-section-nav-->
                                                                    <div class="tab-content">
                                                                        <div role="tabpanel"
                                                                             class="tab-pane fade in active show"
                                                                             id="tabs-3-tab-1">
                                                                            <table :class="['vuetable table table-striped tbl-typical']">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style="width: 50%">Email/Key</th>
                                                                                        <th style="width: 50%">Ftp - Descrição/Host</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr class="bg-gray-light"
                                                                                        style="display: table-row;">
                                                                                        <td>
                                                                                            <span v-if="item.geral.email">
                                                                                                {{ item.geral.email }} - {{ item.geral.email_key }}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span v-if="item.geral.config_ftp">
                                                                                                {{ item.geral.config_ftp.descr }} - {{ item.geral.config_ftp.host }}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </section>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--.tab-pane-->
                <div role="tabpanel"
                     class="tab-pane fade"
                     id="tabs-1-tab-2"
                     aria-expanded="true">
                    <div class="row match-height"
                         v-bind:class="{ fullscreen_expand: isFullscreen }">
                        <div class="col-xl-12 col-lg-12">
                            <div class="card"
                                 style="">
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <div class="card-header">
                                        <h4 class="card-title">Gerais</h4>
                                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                        <div class="heading-elements">
                                            <ul class="nav nav-tabs nav-topline nav-justified"
                                                role="tablist">
                                                <li><a @click="onCreateCliente()"
                                                       v-b-tooltip
                                                       title="Cadastrar EDI de Saída"><i class="ft-plus"
                                                           v-if="getPermission('parametrizacaoedi.store')"></i></a></li>
                                                <li><a @click="onActivateDesactivate(1, null, false)"
                                                       v-b-tooltip
                                                       title="Ativar Registros"
                                                       v-if="getPermission('parametrizacaoedi.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                                <li><a @click="onActivateDesactivate(2, null, false)"
                                                       v-b-tooltip
                                                       title="Inativar Registros"
                                                       v-if="getPermission('parametrizacaoedi.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                                <li><a @click="expandFullscreen()"
                                                       v-b-tooltip
                                                       title="Expande a tela"
                                                       v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                                <li><a @click="expandFullscreen()"
                                                       v-b-tooltip
                                                       title="Minimiza a tela"
                                                       v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                                <li><a @click="onFilterShowHide()"
                                                       v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="card-content">
                                        <div class="table-responsive col-md-12">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 20%">Layout</th>
                                                        <th style="width: 50%">Pessoa</th>
                                                        <th style="width: 20%">Status</th>
                                                        <th style="width: 10%">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="this.form_edi_pessoa.length>0">
                                                    <template v-for="item in this.form_edi_pessoa">
                                                        <tr class="bg-gray-light"
                                                            style="display: table-row;">
                                                            <td>
                                                                {{ item.geral.b_layout.descr }}
                                                            </td>
                                                            <td v-if="item.geral.pessoa.pessoa_fisica!==null">
                                                                {{ item.geral.pessoa.pessoa_fisica.nome }}
                                                            </td>
                                                            <td v-if="item.geral.pessoa.pessoa_exterior!==null">
                                                                {{ item.geral.pessoa.pessoa_exterior.nome }}
                                                            </td>
                                                            <td v-if="item.geral.pessoa.pessoa_juridica!==null">
                                                                {{ item.geral.pessoa.pessoa_juridica.razao_social }}
                                                            </td>
                                                            <td>
                                                                <span class="badge badge-success"
                                                                      v-if="item.geral.status.valor==1">{{ item.geral.status.descr }}</span>
                                                                <span class="badge badge-danger"
                                                                      v-if="item.geral.status.valor==2">{{ item.geral.status.descr }}</span>
                                                            </td>
                                                            <td>
                                                                <a @click="onEditCliente(item)"
                                                                   v-b-tooltip
                                                                   title="Editar"
                                                                   v-if="getPermission('parametrizacaoedi.update')"><i class="fa fa-edit"></i></a>
                                                                <a @click="onCreateProgramado(item)"
                                                                   v-b-tooltip
                                                                   title="Cadastrar Programação"
                                                                   v-if="getPermission('parametrizacaoedi.store')"><i class="fa fa-edit"></i></a>
                                                                <a @click="onCreateRegra(item)"
                                                                   v-b-tooltip
                                                                   title="Cadastrar Regra"
                                                                   v-if="getPermission('parametrizacaoedi.store')"><i class="fa fa-edit"></i></a>
                                                                <a @click="onCreateIntegracao(item)"
                                                                   v-b-tooltip
                                                                   title="Cadastrar Integração"
                                                                   v-if="getPermission('parametrizacaoedi.store')"><i class="fa fa-edit"></i></a>
                                                                <a @click="onDetailPessoa(item)"
                                                                   v-if="item.geral.pessoa_layout_programado!==null"
                                                                   v-b-tooltip
                                                                   title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="isVisibleDetailRowPessoa(item.geral.peslay_id)">
                                                            <td colspan="4">
                                                                <section class="tabs-section">
                                                                    <div class="tabs-section-nav">
                                                                        <div class="tbl">
                                                                            <ul class="nav"
                                                                                role="tablist">
                                                                                <li v-if="item.pessoa_layout_programado!==null"
                                                                                    class="nav-item">
                                                                                    <a class="nav-link active"
                                                                                       href="#tabs-2-tab-1"
                                                                                       role="tab"
                                                                                       data-toggle="tab">
                                                                                        <span class="nav-link-in">
                                                                                            Programado
                                                                                            <i class="fa fa-bulding"></i>
                                                                                        </span>
                                                                                    </a>
                                                                                </li>
                                                                                <li v-if="item.geral.pessoa_layout_regra!==null"
                                                                                    class="nav-item">
                                                                                    <a class="nav-link"
                                                                                       href="#tabs-2-tab-2"
                                                                                       role="tab"
                                                                                       data-toggle="tab">
                                                                                        <span class="nav-link-in">
                                                                                            Regra
                                                                                            <i class="fa fa-bulding"></i>
                                                                                        </span>
                                                                                    </a>
                                                                                </li>
                                                                                <li v-if="item.geral.pessoa_layout_integracao!==null"
                                                                                    class="nav-item">
                                                                                    <a class="nav-link"
                                                                                       href="#tabs-3-tab-3"
                                                                                       role="tab"
                                                                                       data-toggle="tab">
                                                                                        <span class="nav-link-in">
                                                                                            Integração
                                                                                            <i class="fa fa-refresh"></i>
                                                                                        </span>
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <!--.tabs-section-nav-->
                                                                    <div class="tab-content">
                                                                        <div role="tabpanel"
                                                                             class="tab-pane fade in active show"
                                                                             id="tabs-2-tab-1">
                                                                            <table :class="['vuetable table table-striped tbl-typical']">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style="width: 30%">Dia/Mês/Dia da Semana</th>
                                                                                        <th style="width: 25%">Data Final</th>
                                                                                        <th style="width: 25%">Período</th>
                                                                                        <th style="width: 10%">Status</th>
                                                                                        <th style="width: 10%">Ações</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="item_prog in item.geral.pessoa_layout_programado"
                                                                                        class="bg-gray-light"
                                                                                        style="display: table-row;">
                                                                                        <td>
                                                                                            {{ item_prog.dia }} / {{ item_prog.mes}} / {{ item_prog.dia_semana.descr }}
                                                                                        </td>
                                                                                        <td>
                                                                                            {{ formatDate(item_prog.dt_final) }}
                                                                                        </td>
                                                                                        <td>
                                                                                            {{ item_prog.tp_periodo.descr }}
                                                                                        </td>
                                                                                        <td>
                                                                                            <span class="badge badge-success"
                                                                                                  v-if="item_prog.status.valor==1">{{ item_prog.status.descr }}</span>
                                                                                            <span class="badge badge-danger"
                                                                                                  v-if="item_prog.status.valor==2">{{ item_prog.status.descr }}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a @click="onEditProgramado(item_prog)"
                                                                                               v-b-tooltip
                                                                                               title="Editar"
                                                                                               v-if="getPermission('parametrizacaoedi.update')"><i class="fa fa-edit"></i></a>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div role="tabpanel"
                                                                             class="tab-pane fade"
                                                                             id="tabs-2-tab-2">
                                                                            <table :class="['vuetable table table-striped tbl-typical']">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style="width: 60%">Regra Layout</th>
                                                                                        <th style="width: 20%">Status</th>
                                                                                        <th style="width: 10%">Ações</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="item_regra in item.geral.pessoa_layout_regra"
                                                                                        class="bg-gray-light"
                                                                                        style="display: table-row;">
                                                                                        <td>
                                                                                            {{ item_regra.b_layout_regra.descr }}
                                                                                        </td>
                                                                                        <td>
                                                                                            <span class="badge badge-success"
                                                                                                  v-if="item_regra.status.valor==1">{{ item_regra.status.descr }}</span>
                                                                                            <span class="badge badge-danger"
                                                                                                  v-if="item_regra.status.valor==2">{{ item_regra.status.descr }}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a @click="onEditRegra(item_regra)"
                                                                                               v-b-tooltip
                                                                                               title="Editar"
                                                                                               v-if="getPermission('parametrizacaoedi.update')"><i class="fa fa-edit"></i></a>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div role="tabpanel"
                                                                             class="tab-pane fade"
                                                                             id="tabs-3-tab-3">
                                                                            <table :class="['vuetable table table-striped tbl-typical']">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style="width: 20%">Status FTP</th>
                                                                                        <th style="width: 20%">FTP</th>
                                                                                        <th style="width: 20%">Status Email</th>
                                                                                        <th style="width: 20%">Email</th>
                                                                                        <th style="width: 10%">Ações</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="item_integracao in item.geral.pessoa_layout_integracao"
                                                                                        class="bg-gray-light"
                                                                                        style="display: table-row;">
                                                                                        <td>
                                                                                            <span class="badge badge-success"
                                                                                                  v-if="item_integracao.status_ftp.valor==1">{{ item_integracao.status_ftp.descr }}</span>
                                                                                            <span class="badge badge-danger"
                                                                                                  v-if="item_integracao.status_ftp.valor==2">{{ item_integracao.status_ftp.descr }}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span v-if="item_integracao.config_ftp">
                                                                                                {{ item_integracao.config_ftp.descr }}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span class="badge badge-success"
                                                                                                  v-if="item_integracao.status_email.valor==1">{{ item_integracao.status_email.descr }}</span>
                                                                                            <span class="badge badge-danger"
                                                                                                  v-if="item_integracao.status_email.valor==2">{{ item_integracao.status_email.descr }}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span v-if="item_integracao.email">
                                                                                                {{ item_integracao.email }}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <a @click="onEditIntegracao(item_integracao)"
                                                                                               v-b-tooltip
                                                                                               title="Editar"
                                                                                               v-if="getPermission('parametrizacaoedi.update')"><i class="fa fa-edit"></i></a>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </section>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModal"
                     @ok="handleOk">

               <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                   <b-form-text>Extensão Arq.</b-form-text>
                   <b-form-input type="text"
                                 placeholder="Extensão Arq."
                                 v-model="form.extensao_arq"
                                 name="extensao_arq"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form.errors.get('extensao_arq')" v-if="form.errors.has('extensao_arq')"></b-form-feedback>

                   <b-form-text>Email</b-form-text>
                   <b-form-input type="text"
                                 placeholder="Email"
                                 v-model="form.email"
                                 name="email"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form.errors.get('email')" v-if="form.errors.has('email')"></b-form-feedback>

                   <b-form-text>Email Key</b-form-text>
                   <b-form-input type="text"
                                 placeholder="Email Key"
                                 v-model="form.email_key"
                                 name="email_key"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form.errors.get('email_key')" v-if="form.errors.has('email_key')"></b-form-feedback>

                   <b-form-text>Status Email</b-form-text>
                   <multiselect v-model="form.status_email"
                   :options="optionsLivStatusEmail"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('status_email.value')" v-if="form.errors.has('status_email.value')"></b-form-feedback>

                   <b-form-text>Layout</b-form-text>
                   <multiselect v-model="form.layout"
                   :options="optionsLayout"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('layout.value')" v-if="form.errors.has('layout.value')"></b-form-feedback>

                   <b-form-text>FTP</b-form-text>
                   <multiselect v-model="form.ftp"
                   :options="optionsFtp"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('ftp.value')" v-if="form.errors.has('ftp.value')"></b-form-feedback>

                   <b-form-text>Status FTP</b-form-text>
                   <multiselect v-model="form.status_ftp"
                   :options="optionsLivStatusFtp"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('status_ftp.value')" v-if="form.errors.has('status_ftp.value')"></b-form-feedback>

                   <b-form-text>Status</b-form-text>
                   <multiselect v-model="form.status"
                   :options="optionsLivStatus"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

               </form>
                      <div slot="modal-footer" class="w-100">
                             <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                             <div class="float-right">
                                 <b-btn @click="showModal=false" variant="secondary">
                                   Fechar
                                 </b-btn>
                                 <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                                   Enviar
                                 </b-btn>
                             </div>
                      </div>
                  </b-modal>
            <b-modal id="modal_form_cliente"
                     ref="modal_form_cliente"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalCliente"
                     @ok="handleOkCliente">

                 <form @submit.stop.prevent="handleOkCliente" @keydown="form.errors.clear($event.target.name)">
                   <b-col>
                       <b-form-text>Layout</b-form-text>
                       <multiselect v-model="form_cliente.layout"
                       :options="optionsLayout"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_cliente.errors.get('layout.value')" v-if="form_cliente.errors.has('layout.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                       <b-form-text>Status</b-form-text>
                       <multiselect v-model="form_cliente.status"
                       :options="optionsLivStatusPessoaLayout"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_cliente.errors.get('status.value')" v-if="form_cliente.errors.has('status.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                     <b-form-text>Cliente</b-form-text>
                     <multiselect v-model="form_cliente.cliente"
                     :options-limit="300"
                     :limit="2"
                     :limit-text="limitText"
                     :options="optionsCliente"
                     track-by="value"
                     label="label"
                     :hide-selected="true"
                     placeholder="Cliente ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                     tag-placeholder="Selecionar"
                     select-label="Selecionar"
                     selected-label="Selecionado"
                     deselect-label="Remover"
                     :searchable="true"
                     :loading="isLoadingCliente"
                     @search-change="listaClientes"
                     ></multiselect>
                     <b-form-feedback class="text-danger" v-text="form.errors.get('cliente')" v-if="form.errors.has('cliente')"></b-form-feedback>
                   </b-col>
                 </form>
                        <div slot="modal-footer" class="w-100">
                               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                               <div class="float-right">
                                   <b-btn @click="showModalCliente=false" variant="secondary">
                                     Fechar
                                   </b-btn>
                                   <b-btn @click="handleOkCliente($event)" variant="primary" :disabled="isDisabled">
                                     Enviar
                                   </b-btn>
                               </div>
                        </div>
                    </b-modal>
            <b-modal id="modal_form_programado"
                     ref="modal_form_programado"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalProgramado"
                     @ok="handleOkProgramado">

                   <form @submit.stop.prevent="handleOkProgramado" @keydown="form.errors.clear($event.target.name)">
                     <b-col>
                         <b-form-text>Período</b-form-text>
                         <multiselect v-model="form_programado.periodo"
                         :options="optionsLivPeriodo"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Selecione"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                         <b-form-feedback v-text="form_programado.errors.get('periodo.value')" v-if="form_programado.errors.has('periodo.value')"></b-form-feedback>
                     </b-col>
                     <b-col>
                         <b-form-text>Dia da Semana</b-form-text>
                         <multiselect v-model="form_programado.dia_semana"
                         :options="optionsLivDiaSemana"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Selecione"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                         <b-form-feedback v-text="form_programado.errors.get('dia_semana.value')" v-if="form_programado.errors.has('dia_semana.value')"></b-form-feedback>
                     </b-col>
                     <b-col>
                       <b-row no-gutters>
                         <b-col>
                           <b-form-text>Dia</b-form-text>
                           <b-form-input type="text"
                                         placeholder="Dia"
                                         v-model="form_programado.dia"
                                         name="dia"
                                         >
                           </b-form-input>
                           <b-form-feedback v-text="form_programado.errors.get('dia')" v-if="form_programado.errors.has('dia')"></b-form-feedback>
                         </b-col>
                         <b-col>
                           <b-form-text>Mês</b-form-text>
                           <b-form-input type="text"
                                         placeholder="Mês"
                                         v-model="form_programado.mes"
                                         name="mes"
                                         >
                           </b-form-input>
                           <b-form-feedback v-text="form_programado.errors.get('mes')" v-if="form_programado.errors.has('mes')"></b-form-feedback>
                         </b-col>
                      </b-row>
                  </b-col>
                    <b-col>
                      <b-form-text>Data Final</b-form-text>
                      <b-form-input type="text"
                                    placeholder="dd/mm/yyyy"
                                    v-mask="'##/##/####'"
                                    v-model="form_programado.dt_final"
                                    name="dt_final"
                                    >
                      </b-form-input>
                      <b-form-feedback v-text="form_programado.errors.get('dt_final')" v-if="form_programado.errors.has('dt_final')"></b-form-feedback>
                    </b-col>
                     <b-col>
                         <b-form-text>Status</b-form-text>
                         <multiselect v-model="form_programado.status"
                         :options="optionsLivStatusPessoaLayout"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Selecione"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                         <b-form-feedback v-text="form_programado.errors.get('status.value')" v-if="form_programado.errors.has('status.value')"></b-form-feedback>
                     </b-col>
                   </form>
                          <div slot="modal-footer" class="w-100">
                                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                 <div class="float-right">
                                     <b-btn @click="showModalProgramado=false" variant="secondary">
                                       Fechar
                                     </b-btn>
                                     <b-btn @click="handleOkProgramado($event)" variant="primary" :disabled="isDisabled">
                                       Enviar
                                     </b-btn>
                                 </div>
                          </div>
            </b-modal>
            <b-modal id="modal_form_regra"
                     ref="modal_form_regra"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalRegra"
                     @ok="handleOkRegra">
                 <form @submit.stop.prevent="handleOkRegra" @keydown="form.errors.clear($event.target.name)">
                   <b-col>
                       <b-form-text>Regra Layout</b-form-text>
                       <multiselect v-model="form_regra.layout_regra"
                       :options="optionsLayoutRegra"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_regra.errors.get('layout_regra.value')" v-if="form_regra.errors.has('layout_regra.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                       <b-form-text>Status</b-form-text>
                       <multiselect v-model="form_regra.status"
                       :options="optionsLivStatusPessoaLayoutRegra"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_regra.errors.get('status.value')" v-if="form_regra.errors.has('status.value')"></b-form-feedback>
                   </b-col>
                </form>
                <div slot="modal-footer" class="w-100">
                    <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                    <div class="float-right">
                       <b-btn @click="showModalRegra=false" variant="secondary">
                         Fechar
                       </b-btn>
                       <b-btn @click="handleOkRegra($event)" variant="primary" :disabled="isDisabled">
                         Enviar
                       </b-btn>
                    </div>
                </div>
            </b-modal>

            <b-modal id="modal_form_integracao"
                     ref="modal_form_integracao"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalIntegracao"
                     @ok="handleOkIntegracao">
                <form @submit.stop.prevent="handleOkRegra" @keydown="form.errors.clear($event.target.name)">
                   <b-col>
                       <b-form-text>Status FTP</b-form-text>
                       <multiselect v-model="form_integracao.status_ftp"
                       :options="optionsLivStatusFtp"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_integracao.errors.get('status_ftp.value')" v-if="form_integracao.errors.has('status_ftp.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                       <b-form-text>Conexão FTP</b-form-text>
                       <multiselect v-model="form_integracao.conftp"
                       :options="optionsFtp"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_integracao.errors.get('conftp.value')" v-if="form_integracao.errors.has('conftp.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                       <b-form-text>Status Email</b-form-text>
                       <multiselect v-model="form_integracao.status_email"
                       :options="optionsLivStatusEmail"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Selecione"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_integracao.errors.get('status_email.value')" v-if="form_integracao.errors.has('status_email.value')"></b-form-feedback>
                   </b-col>
                   <b-col>
                     <b-form-text>Email</b-form-text>
                     <b-form-input type="text"
                                   placeholder="Email"
                                   v-model="form_integracao.email"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_integracao.errors.get('email')" v-if="form_integracao.errors.has('email')"></b-form-feedback>
                   </b-col>
                </form>
                <div slot="modal-footer" class="w-100">
                    <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                    <div class="float-right">
                       <b-btn @click="showModalIntegracao=false" variant="secondary">
                         Fechar
                       </b-btn>
                       <b-btn @click="handleOkIntegracao($event)" variant="primary" :disabled="isDisabled">
                         Enviar
                       </b-btn>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

    import moment from 'moment'
    export default {
        components: {},
        data() {
            return {
                visibleDetailRows: [],
                dataExport: [],
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                isFullscreen: false,
                isLoadingCliente: false,
                showModalCliente: false,
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                showModalProgramado: false,
                showModalRegra: false,
                showModalIntegracao: false,
                optionsLivStatus: [],
                optionsLivStatusEmail: [],
                optionsLivStatusFtp: [],
                optionsLivStatusPessoaLayout: [],
                optionsLivStatusPessoaLayoutProgramado: [],
                optionsLivStatusPessoaLayoutRegra: [],
                optionsLivPeriodo: [],
                optionsLivDiaSemana: [],
                optionsPessoaLayout: [],
                optionsFtp: [],
                optionsLayout: [],
                optionsCliente: [],
                optionsLayoutRegra: [],
                form_edi_entrada: [{
                    geral: []
                }],
                form_edi_pessoa: [{
                    geral: []
                }],
                form: new Form({
                    email: '',
                    email_key: '',
                    extensao_arq: '',
                    bcliedie_id: '',
                    status: [],
                    ftp: [],
                    layout: [],
                    status_email: [],
                    status_ftp: [],
                }),
                form_cliente: new Form({
                    cliente: [],
                    layout: [],
                    status: [],
                }),
                form_programado: new Form({
                    periodo: [],
                    dia: '',
                    mes: '',
                    dt_final: '',
                    dia_semana: [],
                    peslay_id: '',
                    peslaypro_id: '',
                    status: [],
                }),
                form_regra: new Form({
                    layout_regra: [],
                    status: [],
                    peslay_id: '',
                    peslayreg_id: '',
                }),
                form_integracao: new Form({
                    layout_regra: [],
                    status_ftp: [],
                    conftp: [],
                    status_email: [],
                    email: '',
                    peslay_id: '',
                    peslayint_id: '',
                }),
                helpForm: new Form({
                    statusRecord: [],
                    params: [],
                    search: ''
                }),
                fields: [],
                css: {
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                },
                moreParams: {}
            }
        },
        mounted() {
            this.getLivGeral();
            this.getData();
            this.getDataPessoa();
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'cd': data_filter.cd,
                    'descr': data_filter.descr,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => {
                    this.$refs.vuetable.refresh();
                })
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            isVisibleDetailRow(rowId) {
                return this.visibleDetailRows.indexOf(rowId) >= 0
            },
            showDetailRow(rowId) {
                if (!this.isVisibleDetailRow(rowId)) {
                    this.visibleDetailRows.push(rowId)
                }
            },
            hideDetailRow(rowId) {
                if (this.isVisibleDetailRow(rowId)) {
                    this.visibleDetailRows.splice(
                        this.visibleDetailRows.indexOf(rowId),
                        1
                    )
                }
            },
            toggleDetailRow(rowId) {
                if (this.isVisibleDetailRow(rowId)) {
                    this.hideDetailRowPessoa(rowId)
                } else {
                    this.showDetailRowPessoa(rowId)
                }
            },
            isVisibleDetailRowPessoa(rowId) {
                return this.visibleDetailRows.indexOf(rowId) >= 0
            },
            showDetailRowPessoa(rowId) {
                if (!this.isVisibleDetailRowPessoa(rowId)) {
                    this.visibleDetailRows.push(rowId)
                }
            },
            hideDetailRowPessoa(rowId) {
                if (this.isVisibleDetailRowPessoa(rowId)) {
                    this.visibleDetailRows.splice(
                        this.visibleDetailRows.indexOf(rowId),
                        1
                    )
                }
            },
            toggleDetailRowPessoa(rowId) {
                if (this.isVisibleDetailRowPessoa(rowId)) {
                    this.hideDetailRowPessoa(rowId)
                } else {
                    this.showDetailRowPessoa(rowId)
                }
            },
            onDetail(data) {
                this.toggleDetailRow(data.geral.bcliedie_id);
            },
            onDetailPessoa(data) {
                this.toggleDetailRowPessoa(data.geral.peslay_id);
            },
            onReloadVuetable() {
                this.$refs.vuetable.reload();
            },
            formatDate(value, fmt = 'DD/MM/YYYY') {
                return (value == null) ?
                    '' :
                    moment(value, 'YYYY/MM/DD').format(fmt)
            },
            limitText(count) {
                return ' e ${count} outros clientes'
            },
                        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
              return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
            },
            getData() {
                this.form.get('/api/parametrizacaoedi/edi').then(response => {
                        this.form_edi_entrada = null;
                        this.form_edi_entrada = [];
                        response.data.forEach((obj) => {
                            this.form_edi_entrada.push({
                                geral: obj
                            })
                        });
                        this.loadingData = false;
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            getDataPessoa() {
                this.form.get('/api/parametrizacaoedi/pessoa').then(response => {
                        this.form_edi_pessoa = null;
                        this.form_edi_pessoa = [];
                        response.forEach((obj) => {
                            this.form_edi_pessoa.push({
                                geral: obj
                            })
                        });
                        this.loadingData = false;
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleOk(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStore();
                } else {
                    this.onUpdate(this.form.bcliedie_id);
                }
            },
            handleOkCliente(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStoreCliente();
                } else {
                    this.onUpdateCliente(this.form_cliente.peslay_id);
                }
            },
            handleOkIntegracao(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStoreIntegracao();
                } else {
                    this.onUpdateIntegracao(this.form_integracao.peslay_id);
                }
            },
            onCreateCliente() {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar EDI Saída";
                this.modal_botao = "Cadastrar EDI Saída";
                this.modal_acao = "i";
                this.form_cliente.reset();
                this.$refs.modal_form_cliente.show();
            },
            onEditCliente(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar EDI Saída";
                this.modal_botao = "Alterar EDI Saída";
                this.modal_acao = "u";
                this.form_cliente.reset();
                this.form_cliente.status = {
                    label: data.geral.status.descr,
                    value: data.geral.status.valor
                };
                this.form_cliente.layout = {
                    label: data.geral.b_layout.descr,
                    value: data.geral.b_layout.blay_id
                };
                if (data.geral.pessoa.pessoa_juridica !== null) {
                    this.form_cliente.cliente = {
                        label: data.geral.pessoa.cd + " - " + data.geral.pessoa.pessoa_juridica.razao_social + " - " + this.onFormataCnpj(data.geral.pessoa.pessoa_juridica.cnpj_base, data.geral.pessoa.pessoa_juridica.cnpj_filial, data.geral
                            .pessoa.pessoa_juridica.cnpj_digito) + " - " + data.geral.pessoa.pessoa_juridica.inscricao_estadual,
                        value: data.geral.pessoa.pessoa_id
                    };
                }
                if (data.geral.pessoa.pessoa_exterior !== null) {
                    this.form_cliente.cliente = {
                        label: data.geral.pessoa.cd + " - " + data.geral.pessoa.pessoa_exterior.nome + " - " + data.geral.pessoa.pessoa_exterior.cuit,
                        value: data.geral.pessoa.pessoa_id
                    };
                }
                if (data.geral.pessoa.pessoa_fisica !== null) {
                    this.form_cliente.cliente = {
                        label: data.geral.pessoa.cd + " - " + data.geral.pessoa.pessoa_fisica.nome + " - " + data.geral.pessoa.pessoa_fisica.cpf,
                        value: data.geral.pessoa.pessoa_id
                    };
                }
                this.form_cliente.peslay_id = data.geral.peslay_id;
                this.$refs.modal_form_cliente.show();
            },
            onStoreCliente() {
                this.loading = true;
                this.isDisabled = true;
                this.form_cliente.post('/api/parametrizacaoedi/store/cliente').then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdateCliente(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form_cliente.post('/api/parametrizacaoedi/update/cliente/' + id).then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleOkProgramado(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStoreProgramado();
                } else {
                    this.onUpdateProgramado(this.form_programado.peslaypro_id);
                }
            },
            onCreateIntegracao(data) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar Integração";
                this.modal_botao = "Cadastrar Integração";
                this.modal_acao = "i";
                this.form_integracao.reset();
                this.form_integracao.peslay_id = data.geral.peslay_id;
                this.$refs.modal_form_integracao.show();
            },
            onEditIntegracao(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar Integração";
                this.modal_botao = "Alterar Integração";
                this.modal_acao = "u";
                this.form_integracao.reset();
                this.form_integracao.status_ftp = {
                    label: data.status_ftp.descr,
                    value: data.status_ftp.valor
                };
                this.form_integracao.conftp = {
                    label: data.config_ftp.descr,
                    value: data.config_ftp.conftp_id
                };
                this.form_integracao.status_email = {
                    label: data.status_email.descr,
                    value: data.status_email.valor
                };
                this.form_integracao.email = data.email;
                this.form_integracao.peslay_id = data.peslay_id;
                this.form_integracao.peslayint_id = data.peslayint_id;
                this.$refs.modal_form_integracao.show();
            },
            onStoreIntegracao() {
                this.loading = true;
                this.isDisabled = true;
                this.form_integracao.post('/api/parametrizacaoedi/store/integracao').then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdateIntegracao(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form_integracao.post('/api/parametrizacaoedi/update/integracao/' + id).then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onCreateProgramado(data) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar Programação";
                this.modal_botao = "Cadastrar Programação";
                this.modal_acao = "i";
                this.form_programado.reset();
                this.form_programado.peslay_id = data.geral.peslay_id;
                this.$refs.modal_form_programado.show();
            },
            onEditProgramado(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar Programação";
                this.modal_botao = "Alterar Programação";
                this.modal_acao = "u";
                this.form_programado.reset();
                this.form_programado.status = {
                    label: data.status.descr,
                    value: data.status.valor
                };
                this.form_programado.periodo = {
                    label: data.tp_periodo.descr,
                    value: data.tp_periodo.valor
                };
                this.form_programado.dia_semana = {
                    label: data.dia_semana.descr,
                    value: data.dia_semana.valor
                };
                this.form_programado.dia = data.dia;
                this.form_programado.mes = data.mes;
                this.form_programado.dt_final = data.dt_final;
                this.form_programado.peslay_id = data.peslay_id;
                this.form_programado.peslaypro_id = data.peslaypro_id;
                this.$refs.modal_form_programado.show();
            },
            onStoreProgramado() {
                this.loading = true;
                this.isDisabled = true;
                this.form_programado.post('/api/parametrizacaoedi/store/programado').then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdateProgramado(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form_programado.post('/api/parametrizacaoedi/update/programado/' + id).then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleOkRegra(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStoreRegra();
                } else {
                    this.onUpdateRegra(this.form_regra.peslayreg_id);
                }
            },
            onCreateRegra(data) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar Regra";
                this.modal_botao = "Cadastrar Regra";
                this.modal_acao = "i";
                this.form_regra.reset();
                this.form_regra.peslay_id = data.geral.peslay_id;
                this.$refs.modal_form_regra.show();
            },
            onEditRegra(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar Regra";
                this.modal_botao = "Alterar Regra";
                this.modal_acao = "u";
                this.form_regra.reset();
                this.form_regra.status = {
                    label: data.status.descr,
                    value: data.status.valor
                };
                this.form_regra.layout_regra = {
                    label: data.b_layout_regra.descr,
                    value: data.b_layout_regra.blayreg_id
                };
                this.form_regra.peslay_id = data.peslay_id;
                this.form_regra.peslayreg_id = data.peslayreg_id;
                this.$refs.modal_form_regra.show();
            },
            onStoreRegra() {
                this.loading = true;
                this.isDisabled = true;
                this.form_regra.post('/api/parametrizacaoedi/store/regra').then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdateRegra(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form_regra.post('/api/parametrizacaoedi/update/regra/' + id).then(response => {
                        new ReturnApi(response, this)
                        this.getDataPessoa();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onCreate() {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar";
                this.modal_botao = "Cadastrar";
                this.modal_acao = "i";
                this.form.reset();
                this.$refs.modal_form.show();
            },
            onEdit(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar";
                this.modal_botao = "Alterar";
                this.modal_acao = "u";
                this.form.reset();
                this.form.email = data.geral.email;
                this.form.email_key = data.geral.email_key;
                this.form.extensao_arq = data.geral.extensao_arq;
                this.form.status = {
                    label: data.geral.status.descr,
                    value: data.geral.status.valor
                };

                this.form.status_ftp = {
                    label: data.geral.status_ftp.descr,
                    value: data.geral.status_ftp.valor
                };
                this.form.status_email = {
                    label: data.geral.status_email.descr,
                    value: data.geral.status_email.valor
                };
                if (data.geral.config_ftp !== null) {
                    this.form.ftp = {
                        label: data.geral.config_ftp.descr,
                        value: data.geral.config_ftp.valor
                    };
                }
                this.form.layout = {
                    label: data.geral.b_layout.descr,
                    value: data.geral.b_layout.blay_id
                };

                this.form.bcliedie_id = data.geral.bcliedie_id;
                this.$refs.modal_form.show();
            },
            onStore() {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/parametrizacaoedi/store').then(response => {
                        new ReturnApi(response, this)
                        this.getData();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdate(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form.post('/api/parametrizacaoedi/update/' + id).then(response => {
                        new ReturnApi(response, this)
                        this.getData();
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            listaClientes(search) {
                if (search.length >= 3) {
                    this.isLoadingCliente = true;
                    this.helpForm.search = search;
                    this.helpForm.post('/api/pessoa/jsonlist').then(response => {
                            this.optionsCliente = [];
                            new ReturnApi(response, this, true, false, false);
                            response.items.forEach((obj) => {
                                this.optionsCliente.push({
                                    label: "PJ" + " - " + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj(obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito) + " - " + obj.inscricao_estadual,
                                    value: obj.pessoa_id
                                })
                            });
                            response.itemsE.forEach((obj) => {
                                this.optionsCliente.push({
                                    label: "PE" + " - " + obj.pessoa.cd + " - " + obj.nome + " - " + obj.cuit,
                                    value: obj.pessoa_id
                                })
                            });
                            response.itemsF.forEach((obj) => {
                                this.optionsCliente.push({
                                    label: "PF" + " - " + obj.pessoa.cd + " - " + obj.nome + " - " + obj.cpf,
                                    value: obj.pessoa_id
                                })
                            });
                            this.isLoadingCliente = false;
                        })
                        .catch(errors => {
                            new ReturnApi(errors, this)
                        });
                }
            },
            getLivGeral() {
                this.helpForm.get('/api/parametrizacaoedi/jsonlist').then(response => {
                        new ReturnApi(response, this, true, false, false);
                        // b_cliente_edi_entrada
                        response.status_bcliente_entrada.forEach((obj) => {
                            this.optionsLivStatus.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        response.status_email.forEach((obj) => {
                            this.optionsLivStatusEmail.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        response.status_ftp.forEach((obj) => {
                            this.optionsLivStatusFtp.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // pessoa_layout
                        response.status_pessoa_layout.forEach((obj) => {
                            this.optionsLivStatusPessoaLayout.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // pessoa_layout_programado
                        response.status_pessoa_layout_programado.forEach((obj) => {
                            this.optionsLivStatusPessoaLayoutProgramado.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // pessoa_layout_regra
                        response.status_pessoa_layout_regra.forEach((obj) => {
                            this.optionsLivStatusPessoaLayoutRegra.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // pessoa_layout_programado
                        response.tp_periodo.forEach((obj) => {
                            this.optionsLivPeriodo.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // pessoa_layout_programado
                        response.dia_semana.forEach((obj) => {
                            this.optionsLivDiaSemana.push({
                                label: obj.descr,
                                value: obj.valor
                            })
                        })

                        // /api/blayout/jsonlist').then(response =>
                        response.blayout.forEach((obj) => {
                            this.optionsLayout.push({
                                label: obj.descr,
                                value: obj.blay_id
                            })
                        })

                        // configftp
                        response.configftp.forEach((obj) => {
                            this.optionsFtp.push({
                                label: obj.descr,
                                value: obj.conftp_id
                            })
                        })

                        // pessoa layout
                        // this.helpForm.get('/api/pessoalayout/jsonlist').then(response =>
                        response.pessoa_layout.forEach((obj) => {
                            if (obj.pessoa.pessoa_fisica !== null) {
                                this.optionsPessoaLayout.push({
                                    label: "PF" + " - " + obj.pessoa.pessoa_fisica.nome + " - " + obj.b_layout.descr,
                                    value: obj.peslay_id
                                })
                            }
                            if (obj.pessoa.pessoa_exterior !== null) {
                                this.optionsPessoaLayout.push({
                                    label: "PE" + " - " + obj.pessoa.pessoa_exterior.nome + " - " + obj.b_layout.descr,
                                    value: obj.peslay_id
                                })
                            }
                            if (obj.pessoa.pessoa_juridica !== null) {
                                this.optionsPessoaLayout.push({
                                    label: "PJ" + " - " + obj.pessoa.pessoa_juridica.razao_social + " - " + obj.b_layout.descr,
                                    value: obj.peslay_id
                                })
                            }
                        })

                        // blayoutregra
                        response.blayoutregra.forEach((obj) => {
                            this.optionsLayoutRegra.push({
                                label: obj.status,
                                value: obj.blayreg_id
                            })
                        })



                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onActivateDesactivate(action, data, tipo) {
                // Tipo = true = Checkbox
                if (tipo) {
                    this.helpForm.statusRecord = [];
                    this.helpForm.statusRecord.push({
                        id: data.bcliedie_id,
                        status: action
                    });
                } else {
                    this.helpForm.statusRecord = [];
                    this.$refs.vuetable.selectedTo.forEach((obj) => {
                        this.helpForm.statusRecord.push({
                            id: obj,
                            status: action
                        })
                    });
                }

                this.helpForm.post('/api/parametrizacaoedi/status').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });

            },
            onError(response) {
                new ReturnApi(response.response, this, true, true, false);
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.state.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            }
        }
    }

</script>